// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './ProgressBar.scss';

const ProgressBar = ({ percentageComplete }) => (
    <div className="ProgressBar">
        <div className="bar" style={{ width: `${percentageComplete}%` }} />
    </div>
);

ProgressBar.propTypes = {
    percentageComplete: PropTypes.number,
};

export default ProgressBar;
